// extracted by mini-css-extract-plugin
export default {"backgr":"character-root_backgr__xDrT7","slide-down":"character-root_slide-down__a8Bwr"};